import {mrbgStore} from "./mrbg/mrbgRedux";
import {useEffect, useState} from "react";

function BlogH1Frame({mainStyle}){

  const
    [pageInfo,setPageInfo] = useState( mrbgStore.getState().mrbgVars.pageInfo );

  useEffect(()=>{
    const unsubscribe = mrbgStore.subscribe(()=>{
      setPageInfo( mrbgStore.getState().mrbgVars.pageInfo )
    })
    return () =>unsubscribe();
  },[])

  return(
    <>
      {
        pageInfo.h1?
          <section id={mainStyle.h1Frame} className={mainStyle.prl_Y}>
            <h1>{pageInfo.h1}</h1>
            <div id="h1_hr"></div>
            <h2>{pageInfo.description}</h2>
          </section>:
        ''
      }
    </>
  )
}
export default BlogH1Frame;